import { CREATE_CAMPAIGN, CREATE_CAMPAIGN_SUCCESS, CREATE_CAMPAIGN_ERROR, CREATE_CAMPAIGN_EMPTY } from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateCampaign = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CAMPAIGN:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_CAMPAIGN_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: action?.payload?.message,
      };
      break;

    case CREATE_CAMPAIGN_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_CAMPAIGN_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateCampaign;
